
/** general categories of punctuation */
export enum PunctuationClass {
  Pause = 'pause',   // ,
  MediumPause = 'mediumPause', // ;
  Stop = 'stop',     // .
  EndParagraph = 'endParagraph', // \n
  StartQuote = 'startQuote',
  EndQuote = 'endQuote',
}

/** a note about how to modify or interpret a word or sentence */
export enum NoteClass {
  AllCaps = 'allCaps',
  Hyphenated = 'hyphenated',

  AddStress = 'addStress',
  LowerStress = 'lowerStress',
  LengthenVowels = 'lengthenVowels',
  AsIs = 'asIs',
  Tone = 'tone',

  Uptalk = 'uptalk',
}

export interface WordUnit {
  /** the original word or punctuation symbols in this unit */
  readonly input: string,
  /** transformed result */
  readonly output?: string,
  /** if unit is punctuation, get the general category */
  readonly punctuation?: PunctuationClass,
  /** any notes attached to this unit */
  readonly notes?: NoteClass[],
  /** if notes include 'Tone', it's one of {1,2,3,4,5,15,51,242,424} */
  readonly tones?: NoteTone,
}

export type NoteTone = 1 | 2 | 3 | 4 | 5 | 15 | 51 | 242 | 424;

export function isPunctuation(unit: WordUnit): boolean {
  return unit.punctuation !== undefined;
}

/** if we should use this unit as-is, without running thru rules */
export function isAsIs(unit: WordUnit): boolean {
  return unit.notes !== undefined && unit.notes.includes(NoteClass.AsIs);
}
